import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "browse-reference" }
const _hoisted_2 = ["onClick"]

import { ref, watch } from 'vue';
import { useTrucodeReferenceStore } from 'stores/references-store';
import {storeToRefs} from 'pinia';
import { TitledObject } from 'src/services/TrucodeReferencesService';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesBrowse',
  setup(__props) {

const nodes = ref<TitledObject[]>([]);
const selected = ref<TitledObject | null>(null);

const referenceStore = useTrucodeReferenceStore();
const { currentBook } = storeToRefs(referenceStore);

function onSelectionChanged(node: TitledObject) {
  if(node?.id && node?.type == 'article') {
    referenceStore.setCurrentArticle(node);
  }
}

watch(currentBook, async (newBook) => {
  if (newBook?.id) {
    let years =  await referenceStore.getBookReferenceYears(newBook.id) || [];
    nodes.value = years.map(year => {
      return {
        id: '' + year,
        type: 'year',
        title: '' + year,
        lazy: true,
        selectable: false
      }});
  }
});

async function loadIssues(id: number) {
  return (await referenceStore.getBookReferenceYearIssue(id) || []).map(result => {
    result.type = 'issue';
    result.lazy = true;
    result.selectable = false;
    return result;
  });
}

async function loadArticles(id: number) {
  return (await referenceStore.getReferencesArticles(id) || []).map(result => {
    result.type = 'article';
    result.selectable = true;
    return result;
  });
}

async function loadNodes({ node, key, done, fail }) {
  try {
    switch(node.type) {
      case 'year':
        done(await loadIssues(key));
        break;
      case 'issue':
        done(await loadArticles(key));
        break;
    }
  }catch (err) {
    fail(err);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_tree = _resolveComponent("q-tree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_tree, {
      nodes: nodes.value,
      "node-key": "id",
      "no-connectors": "",
      icon: "fa-solid fa-caret-right",
      class: "iodine-padding-left-lg",
      selected: selected.value,
      "onUpdate:selected": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
      onLazyLoad: loadNodes
    }, {
      "default-header": _withCtx((prop) => [
        _createElementVNode("div", {
          class: "row items-center browse-result-item iodine-padding-left-sm",
          onClick: ($event: any) => (onSelectionChanged(prop.node))
        }, [
          _createElementVNode("div", null, _toDisplayString(prop.node.title), 1)
        ], 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["nodes", "selected"])
  ]))
}
}

})